<template>
  <header id="gnb" class="mmp_header theme_dark fixed">
    <div class="inner">
      <!-- 메인 헤더 영역 -->
      <div class="wrap_header">
        <!-- 헤더 상단 영역 (로고, 유틸 메뉴) -->
        <div class="top">
          <!-- 카테고리 버튼 (MO 전용) -->
          <button
            v-if="isMobile"
            ref="categoryMenuBtn"
            class="btn_category"
          >카테고리</button>
          <!-- // 카테고리 버튼 (MO전용) -->
          <!-- 로고 -->
          <h1>
            <a class="home_link" style="cursor: pointer" @click="goMain">MULTICAMPUS</a>
          </h1>
          <!-- // 로고 -->
          <!-- 유틸 메뉴 영역 -->
          <div class="wrap_util_menu">
            <!-- 상단 버튼 영역 -->
            <ul class="top_button">
              <li v-if="isDesktop">
                <button
                  :class="[isOpenSearchPop ? 'active' : '']"
                  class="btn_top_icon search"
                  @click="onClickTotalSearch">통합검색</button>
              </li>
              <li v-if="isLogin">
                <!-- NOTE: 알람이 존재하는 경우 'active' 클래스 추가 -->
                <button
                  ref="headerAlarmBtn"
                  :class="{'active': newAlramCount > 0}"
                  data-name="AlarmBtn"
                  class="btn_top_icon alarm"
                  @click="onClickAlram('gnb__alarm')"
                >알림</button>

                <!-- 알림 컨텐츠 -->
                <div class="gnb__layer gnb__alarm">
                  <div class="head">
                    <div class="head_tit">신규알림 <span class="text__blue">{{ newAlramCount || 0 }}</span></div>
                    <!-- 알림 목록이 없을 때 미노출 -->
                    <div v-if="alramList" class="head_desc">※ 최근 6개월간 활동에 대한 알림입니다.</div>
                  </div>

                  <div class="cont">
                    <div v-if="!alramList" class="no_item_wrap">
                      <div class="no_item">
                        <p class="no_item_txt">등록된 알림이 없습니다.</p>
                      </div>
                    </div>
                    <ul v-else class="list">
                      <li v-for="(item, index) in alramList" :key="index">
                        <i v-if="item.newYn === 'Y'" class="icon_alarm" />
                        <div>
                          <div class="list_tit">{{ item.alarmClsfNm }}</div>
                          <div class="list_desc">{{ item.alarmMsgCntnt }}</div>
                          <div class="list_info">{{ item.fstRegDtm }}</div>
                        </div>
                      </li>
                    </ul>
                    <div v-if="isShowMore" class="wrap_more_btn">
                      <button
                        type="button"
                        class="btn__box-stroke"
                        @click="showMore">더보기</button>
                    </div>
                  </div>

                </div>
                <!-- // 알림 컨텐츠 -->
              </li>

              <li v-if="isDesktop">
                <button
                  ref="headerMemberBtn"
                  data-name="MemberBtn"
                  class="btn_top_icon member"
                  @click="memberClick"
                >멤버</button>

                <div v-if="isLogin" class="gnb__layer gnb__member">
                  <ul class="list">
                    <li><a href="javascript:void(0)" @click="moveMypage">나의공간</a></li>
                    <li><a href="javascript:void(0)" @click="logOut">로그아웃</a></li>
                  </ul>
                </div>

                <!-- 로그인 전-->
                <!-- <button
                  v-if="!isLogin"
                  class="btn_top_icon member"
                  @click="moveToLogin('javascript:void(0)')"
                >멤버</button> -->

                <!-- 로그인 후 -->
                <!-- <button
                  v-else
                  class="btn_test"
                  @click="moveMypage" >{{ userName }} 님</button> -->
              </li>
              <li v-if="!isDesktop && !isLogin">
                <button
                  data-name="MemberBtn"
                  class="btn_top_icon member"
                  @click="memberClick"
                >멤버</button>
              </li>
            </ul>
            <!-- // 상단 버튼 영역 -->
            <!-- 상단 링크 영역 (PC 전용) -->
            <ul v-if="isDesktop" v-show="menuTopMain.menus && menuTopMain.useYn === 'Y'" class="top_link">
              <li v-for="(menuItem, idx) in menuTopMain.menus" v-show="menuItem.useYn === 'Y'" :key="'MW_MAIN_' + idx">
                <a href="javascript:void(0)" @click="goMenuLink(menuItem)"> {{ menuItem.menuNm }} </a>
              </li>
            </ul>
            <!-- // 상단 링크 영역 (PC 전용) -->
          </div>
          <!-- // 유틸 메뉴 영역 -->
        </div>
        <!-- // 헤더 상단 영역 (로고, 유틸 메뉴) -->
        <!-- 카테고리, 이벤트 메뉴 -->
        <div
          v-if="isDesktop"
          class="wrap_category"
        >
          <!-- 카테고리 메뉴 버튼 -->
          <div class="wrap_category_btn">
            <button
              ref="categoryMenuBtn"
              class="btn_category"
            >카테고리</button>
          </div>
          <!-- // 카테고리 메뉴 버튼 -->
          <!-- 이벤트 접힘 메뉴 (PC 전용) -->
          <div
            v-if="isDesktop && hasEventMenu && isVisible"
            class="wrap_event_menu"
          >
            <div class="inner">
              <!-- 이벤트 메뉴 리스트 -->
              <ul class="list">
                <li v-for="(item, index) in potltData" :key="index">
                  <a
                    href="javascript:void(0)"
                    class="link_event_menu"
                    @click="gotoLink(item)"
                  >{{ item.bannNm }}</a>
                </li>
              </ul>
              <!-- // 이벤트 메뉴 리스트 -->
            </div>

            <!-- 이벤트 리스트 펼침 버튼 -->
            <button
              ref="eventMenuBtn"
              type="button"
              class="btn_event_menu"
            >주요 카테고리 펼쳐 보기</button>
            <!-- // 이벤트 리스트 펼침 버튼 -->

          </div>
          <!-- // 이벤트 접힘 메뉴 (PC 전용) -->
        </div>
        <!-- // 카테고리, 이벤트 메뉴 -->

      </div>
      <!-- // 메인 헤더 영역 -->

      <!-- 카테고리 펼침 메뉴 -->
      <div
        ref="categoryMenu"
        class="wrap_category_menu_expand"
      >
        <CompMmpCategoryMenu
          ref="CompMmpCategoryMenu"
          :category-data="catRoot"
          @closeMo="hideCategoryMenu"
          @beforeCategoryMove="beforeCategoryMove"
          @searchPopOpen="onClickTotalSearch"
        />
      </div>
      <!-- // 카테고리 펼침 메뉴 -->

      <!-- 이벤트 펼침 메뉴 (PC 전용) -->
      <Promotion
        v-if="isDesktop && hasEventMenu"
        ref="eventMenuPc"
        :classes="['wrap_event_menu_expand', {'active' : isEventMenuOpened}]"
        :potlt-info="potltInfo"
        @hideEventMenuPc="hideEventMenuPc"
      />
      <!-- // 이벤트 펼침 메뉴 (PC 전용) -->
    </div>
  </header>
</template>

<script>
import Vue from 'vue'
import { isEmpty, forEach } from 'lodash'
import MotionEffects from '@/assets/js/MotionEffects'
import Promotion from '@/components/pages/nrw/portlet/Promotion.vue'
import CompMmpCategoryMenu from '@/components/pages/nrw/portlet/CompMmpCategoryMenu.vue'
import CompEventMenu from '@/components/pages/nrw/portlet/CompEventMenuMo.vue'
import NrwCommonApi from '~pages/nrw/layouts/NrwCommon.js'

Vue.use(NrwCommonApi)

export default {
  name: 'NrwHeader',
  components: {
    Promotion,
    CompMmpCategoryMenu,
    CompEventMenu
  },
  mixins: [MotionEffects],
  props: {
    potltInfo: {
      type: Object,
      default: () => {}
    },
    portletList: {
      type: Array,
      default: () => []
    },
    isSearchPop: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      hasEventMenu: false, // 이벤트 메뉴 리스트 존재 여부
      htmlClass: 'has_mmp_header', // 헤더 존재를 선언하기 위해 <html> 태그에 추가할 클래스명
      isDesktop: window.vue.getStore('homeInfo').state.isDeskTopMode, // 현재 디바이스 viewport width 가 데스크탑 사이즈인 경우 true
      isMobile: !window.vue.getStore('homeInfo').state.isDeskTopMode, // 현재 디바이스 viewport width 가 모바일 사이즈인 경우 true
      isOpen: false,
      isVisible: false,
      menuCat: [], // 카테고리 메뉴
      menuTopMain: [], // Top Main 메뉴
      scrollGap: 100, // 페이지 스크롤시 숨김 처리하기 위한 스크롤 이동값
      isOpenSearchPop: false,
      showHeader: true,
      isEventMenuOpened: false, // 이벤트 메뉴 활성화 여부
      beforeCategoryMoveFlag: false, // 카테고리 메뉴 클릭전 이벤트 처리 플래그 (true이면 이동, false면 이동 안함, 검색 레이어 닫기시 체크)
      totCnt: null,
      newAlramCount: null,
      alramList: null, // 알림 팝업에 보이는 목록
      showMoreAddCount: 20, // 더보기 수
      showMoreButtonClickCount: 0, // showMoreButton 호출 횟수
      toggleFlg: false
    }
  },
  computed: {
    potltData () {
      const potltInfo = this.portletList.filter(item => item.potltCd === 'NRW_PROMO')
      return potltInfo.length > 0 && potltInfo[0].potltData ? potltInfo[0].potltData : []
    },
    homeStore () {
      return window.vue.getStore('homeInfo')
    },
    fetchFlag () {
      return this.courseStore.state.fetchFlag
    },
    isLogin () {
      return window.vue.getStore('root').state.session.authenticated
    },
    userName () {
      return window.vue.getStore('root').state.session.mbrFnm
    },
    multicampusLink () {
      if (this.$utils.userAgent.isDesktop()) {
        return 'https://www.multicampus.com/main'
      } else {
        return 'https://www.multicampus.com/em/enrolment/courseDetaiInfo/mobileServicePopup'
      }
    },
    catRoot () {
      return Array.prototype.filter.call(this.menuCat, (menu) => menu.id.endsWith('000000000000') )
    },
    // newAlramCount () {
    //   return this.alramList && this.alramList[0].totNewCnt
    // },
    limitCount () {
      return (this.showMoreButtonClickCount + 1) * this.showMoreAddCount
    },
    isShowMore () {
      return this.alramList && this.alramList.length < Number(this.totCnt)
    }
  },
  watch: {
    '$route' (to, from) { // 라우트 변경시
      console.log('라우트 변경:', to, from)
      // 라우트 변경시, 검색창 존재할 경우(모바일만), 검색창을 닫아준다.
      const categoryDiv = document.querySelector('.wrap_category_menu_expand')
      let isShowCategoryMenu = this.isMobile && categoryDiv.classList.contains('active')

      console.log('NrwHeader::watch(라우트 변경)::isShowCategoryMenu', isShowCategoryMenu)
      if (this.isShowCategoryMenu) {
        this.hideCategoryMenu()
      }
    },
    /* isSearchPop (val) {
      this.isOpenSearchPop = val
    }, */
    '$parent.isOpenSearch' (val) {
      this.isOpenSearchPop = val
    },

    /* 부장님 소스 Start */
    potltData (newVal, oldVal) {
      this.isVisible = true
      this.hasEventMenu = true
    },
    'isOpen': {
      handler: function (nVal, oVal) {
        if (this.isOpen) {
          document.body.classList.add('overflow')
        } else {
          document.body.classList.remove('overflow')
        }
      }
    },
    'isLogin': {
      handler: function (nVal, oVal) {
        // window.vue.getStore('cartInfo').dispatch('updateCartCnt')
        this.getNewAlarmList()
      },
      immediate: true
    },
    isMobile () {
      // PC > MO 반응형 감지시 각종 활성화 된 active 클래스 초기화
      this.changeTheme('dark')
      this.closeAllHeaderLayer()
    },
    isDesktop () {
      // MO, PC 반응형 감지시 각종 활성화 된 active 클래스 초기화
      this.closeAllHeaderLayer()
    }
  },
  created () {
    this.$setNrwHeader(this)
  },
  async mounted () {
    this.originalURL = window.location.href
    this.doCheckDeviceType()
    window.addEventListener('resize', this.doCheckDeviceType, true) // mo, pc 구분
    await this.getMenuList() // 메뉴조회
    this.getPromoPortletData() // 프로모션 카테고리 포틀릿 데이터 조회
    // this.selectNewAlarmList() // 신규 알람 조회
    this.event()
    this.addHeaderClass()

    // event listener
    window.addEventListener('click', this.onClick) // 클릭 이벤트 감지
    // window.addEventListener('click', this.bodyClick) // TotalSearchMain 팝업 닫음

    // window.addEventListener('beforeunload', this.unLoadEvent)
  },
  beforeDestroy () {
    window.removeEventListener('resize', this.doCheckDeviceType)
    window.removeEventListener('click', this.onClick)
    // window.removeEventListener('click', this.bodyClick)

    // window.removeEventListener('beforeunload', this.unLoadEvent)
    this.removeHeaderClass()
  },

  // beforeRouteLeave (to, from, next) { // (내부 라우팅)모바일 및 검색 레이어 존재시 레이어만 닫히게
  //   try {
  //     const categoryDiv = document.querySelector('.wrap_category_menu_expand')
  //     let isShowCategoryMenu = this.isMobile && categoryDiv.classList.contains('active')
  //     console.log('NrwHeader::beforeRouteLeave::isShowCategoryMenu', isShowCategoryMenu)
  //     if (isShowCategoryMenu) {
  //       this.hideCategoryMenu()
  //       if (this.beforeCategoryMoveFlag) { // 카테고리 직접 클릭했을 경우에만 이동 시킴
  //         next(true)
  //       } else {
  //         // 이동 막기
  //         next(false)
  //         window.history.pushState(null, '', from.fullPath)
  //       }
  //     } else {
  //       next()
  //     }
  //   } finally {
  //     this.beforeCategoryMoveFlag = false
  //   }
  // },

  methods: {
    // 카테고리 메뉴 클릭시, 이동전 호출
    beforeCategoryMove () {
      console.log('카테고리 메뉴 클릭시, 이동전 호출beforeCategoryMove')
      this.beforeCategoryMoveFlag = true
    },
    // 모바일 및 검색 레이어 존재시 레이어만 닫히게
    async unLoadEvent (event) {
      // try {
      //   const categoryDiv = document.querySelector('.wrap_category_menu_expand')
      //   let isShowCategoryMenu = this.isMobile && categoryDiv.classList.contains('active')
      //   console.log('NrwHeader::unLoadEvent::this.isShowCategoryMenu', isShowCategoryMenu)
      //   if (isShowCategoryMenu) {
      //     this.hideCategoryMenu()
      //     event.preventDefault()
      //     event.returnValue = ''
      //   }
      // } finally {

      // }
    },
    /* bodyClick (event) {
      const searchButton = document.querySelector('.btn_top_icon.search')
      const searchMenu = document.getElementById('mmpSearchMenu')

      const isSearchButton = searchButton && searchButton.contains(event.target)
      const isSearchMenu = searchMenu && searchMenu.contains(event.target)

      // 클릭한 요소가 검색 메뉴, 검색 버튼이 아니면 TotalSearchMain 팝업 닫음
      if (this.isDesktop && !isSearchButton && !isSearchMenu) {
        this.isOpenSearchPop = false
        // this.$search.close()
      }
    }, */
    doCheckDeviceType () {
      this.isDesktop = window.innerWidth > 1199
      this.isMobile = !this.isDesktop
      this.homeStore.commit('SET_DESKTOP_MODE', this.isDesktop)

      const vw = window.innerWidth
      var deviceType = ''
      if (vw >= 1200) {
        deviceType = 'pc'
        this.isDesktop = true
      } else {
        this.isDesktop = false
        if (vw <= 719) { // 360 -> 599 -> 719
          deviceType = 'mobile'
        } else {
          deviceType = 'tablet'
        }
      }
      this.homeStore.commit('SET_DEVICE_TYPE', deviceType)
      this.homeStore.commit('SET_DESKTOP_MODE', this.isDesktop)
    },
    async getMenuList () {
      let promoStore = window.vue.getStore('promoInfo')
      let eduGrpCd = promoStore.state.promoInfo.eduGroupCode
      // 카테고리 메뉴 조회
      this.fetchData('selectCategoryMenu', { eduGrpCd: eduGrpCd }, (data) => {
        console.log('this.menuCat', data.menuList)
        this.menuCat = data.menuList
        const listRoot = Array.prototype.filter.call(this.menuCat, (menu) => menu.id.endsWith('000000000000') )
        forEach(listRoot, (item, idx) => {
          // console.log('item[' + idx + ']', item)
          item.linkUrl = '/corsList'
          item.paramCntnt01 = 'CorsList' // 과정목록
          item.menuNm = item.clsfNm01
          item.paramCntnt02 = item.id
          item.level = 1
          item.isActive = true
          item.menus = Array.prototype.filter.call(this.menuCat, (menu) => menu.clsfCd01 === item.clsfCd01 && menu.clsfCd02 !== item.clsfCd02 && menu.id.endsWith('000000000'))
          forEach(item.menus, (itemSub, idxSub) => {
            itemSub.linkUrl = '/corsList'
            itemSub.paramCntnt01 = 'CorsList' // 과정목록
            itemSub.menuNm = itemSub.clsfNm02
            itemSub.paramCntnt02 = item.id
            itemSub.paramCntnt03 = itemSub.id
            itemSub.level = 2
            itemSub.isActive = false
            itemSub.menus = Array.prototype.filter.call(this.menuCat, (menu) => menu.clsfCd01 === itemSub.clsfCd01 && menu.clsfCd02 === itemSub.clsfCd02 && menu.clsfCd03 !== itemSub.clsfCd03 && menu.id.endsWith('000000'))
            forEach(itemSub.menus, (itemSub1, idxSub1) => {
              itemSub1.linkUrl = '/corsList'
              itemSub1.paramCntnt01 = 'CorsList' // 과정목록
              itemSub1.menuNm = itemSub1.clsfNm03
              itemSub1.paramCntnt02 = item.id
              itemSub1.paramCntnt03 = itemSub.id
              itemSub1.paramCntnt04 = itemSub1.id
              itemSub1.level = 3
              itemSub1.isActive = false
            })
          })
        })
      })

      // PC 메인 탑 메뉴 조회
      this.fetchData('selectMobileMenu', { eduGrpCd: eduGrpCd, menuTyp: 'MW_MAIN' }, (data) => {
        let tmpMenu = this.makeTreeForMenu(data.menuList)
        console.log('this.tmpMenu', tmpMenu)
        this.menuTopMain = tmpMenu.menus && tmpMenu.menus.length > 0 ? tmpMenu.menus[0] : []
        console.log('this.menuTopMain', this.menuTopMain)
      })

      // 나의공간 메뉴 조회
      this.fetchData('selectMobileMenu', { eduGrpCd: eduGrpCd, menuTyp: 'MW_MYSPC' }, (data) => {
        let tmpMenu = this.makeTreeForMenu(data.menuList)
        this.menuMySpc = tmpMenu.menus && tmpMenu.menus.length > 0 ? tmpMenu.menus[0] : []
        console.log('this.menuMySpc', this.menuMySpc)
      })

      // 고객센터 메뉴 조회
      this.fetchData('selectMobileMenu', { eduGrpCd: eduGrpCd, menuTyp: 'MW_CUST' }, (data) => {
        let tmpMenu = this.makeTreeForMenu(data.menuList)
        this.menuCust = tmpMenu.menus && tmpMenu.menus.length > 0 ? tmpMenu.menus[0] : []
        console.log('this.menuCust', this.menuCust)
      })
    },
    // 프로모션 카테고리 포틀릿 데이터 조회
    getPromoPortletData () {
      let homeInfoStore = window.vue.getStore('homeInfo')
      // 프로모션 카테고리 포틀릿 데이터 조회
      if (isEmpty(homeInfoStore.getters.menuPromoCat)) {
        homeInfoStore.dispatch('selectMenuPromoCat', {
          data: { potltCd: 'NRW_PROMO' },
          callback: (result) => {
            homeInfoStore.commit('SET_MENU_PROMO_CAT', result)
          }
        })
      }
    },
    moveToLogin () {
      this.isOpen = false
      this.$goPage({name: 'Login'})
    },
    moveMypage () {
      this.$goPage({'name': 'MyDashbrd'})
      this.isOpen = false
    },
    getNewAlarmList () {
      if (!this.isLogin) return
      const params = {
        offset: 0,
        limit: this.limitCount
      }

      // 신규 알림 개수 조회
      this.fetchData('selectNewAlarmList', params, (data) => {
        if (!data) return

        const totCnt = data.totCnt
        const alarmList = data.listAlarm
        const newAlarmCount = data.listAlarm[0].totNewCnt

        this.totCnt = totCnt
        this.alramList = alarmList
        this.newAlramCount = newAlarmCount
      })
    },
    // 알림 목록 읽음 상태 변경 처리
    updateNewAlarmRead () {
      const list = this.alramList
        .filter(item => item.newYn === 'Y')
        .map(item => ({ alarmClsfCd: item.alarmClsfCd, alarmSno: item.alarmSno }))

      console.log('list==>', list)

      this.fetchData('updateNewAlarmRead', { alarmList: list }, data => {
        console.log('>> updateNewAlarmRead', data)
      })
    },
    // 클릭 이벤트 제어 (클릭시 on/off 요소 관련)
    onClick (e) {
      const srcEl = (e.target) ? e.target : e.srcElement

      if (srcEl.dataset.name !== 'MemberBtn') { // 나의 공간 이미지 클릭할 경우가 아닌 경우만..
        let gnbMember = document.querySelector('.gnb__member')
        if (gnbMember) this.closeGnbLayer('gnb__member')
      }

      // 알림 버튼과 알림 팝업 영역이 아닌 곳을 클릭한 경우, 알림 팝업 닫힘
      if (srcEl.dataset.name !== 'AlarmBtn' && !srcEl.closest('.gnb__layer.gnb__alarm')) {
        const gnbAlarm = document.querySelector('.gnb__alarm')
        if (gnbAlarm) {
          this.toggleFlg = false
          this.$refs.headerAlarmBtn.classList.remove('focus')
          this.closeGnbLayer('gnb__alarm')

          if (document.body.classList.contains('fixed_body')) {
            document.body.classList.remove('fixed_body')
          }
        }
      }

      const _this = this
      const target = e.target
      const triggerEls = [
        {
          name: 'categoryMenu', // 카테고리 메뉴
          trigger: _this.$refs.categoryMenuBtn,
          layerClass: '.wrap_category_menu_expand',
          showPc: function () {
            _this.showCategoryMenu()
          },
          hidePc: function () {
            _this.hideCategoryMenu()
          },
          showMo: function () {
            _this.showCategoryMenu()
          },
          hideMo: function () {
            _this.hideCategoryMenu()
          }
        },
        {
          name: 'eventMenu', // 이벤트 메뉴
          trigger: document.querySelector('.btn_event_menu'),
          layerClass: '.wrap_event_menu_expand',
          showPc: function () {
            _this.showEventMenuPc()
          },
          hidePc: function () {
            _this.hideEventMenuPc()
          },
          showMo: function () {
            _this.showEventMenuMo()
          },
          hideMo: function () {
            _this.hideEventMenuMo()
          }
        }
      ]
      let i, trigger

      for (i = 0; i < triggerEls.length; i++) {
        trigger = triggerEls[i].trigger
        if (target === trigger || target.parentElement === trigger) {
          if (_this.isDesktop) {
            if (trigger.classList.contains('active')) {
              triggerEls[i].hidePc()
            } else {
              triggerEls[i].showPc()
            }
          } else {
            if (trigger.classList.contains('active')) {
              triggerEls[i].hideMo()
            } else {
              triggerEls[i].showMo()
            }
          }
        } else {
          if (_this.isDesktop) {
            if (target.closest(triggerEls[i].layerClass) === null) {
              triggerEls[i].hidePc()
            }
          } else {
            if (target.closest(triggerEls[i].layerClass) === null) {
              triggerEls[i].hideMo()
            }
          }
        }
      }
    },
    // <html> 태그에 헤더 존재를 선언하기 위한 클래스 추가
    addHeaderClass () {
      const htmlTag = document.querySelector('html')
      const htmlClass = this.htmlClass
      if (htmlTag) {
        htmlTag.classList.add(htmlClass)
      }
    },
    // <html> 태그에 헤더 존재를 선언하기 위해 추가한 클래스 제거
    removeHeaderClass () {
      const htmlTag = document.querySelector('html')
      const htmlClass = this.htmlClass
      if (htmlTag && htmlTag.classList.contains(htmlClass)) {
        htmlTag.classList.remove(htmlClass)
      }
    },
    // 헤더에 'has_active_menu' 클래스 추가
    addHeaderActiveClass () {
      const header = document.querySelector('.mmp_header')

      if (header) header.classList.add('has_active_menu')
    },
    // 열려 있는 메뉴가 없는 경우 헤더에 'has_active_menu' 클래스 제거
    removeHeaderActiveClass () {
      const header = document.querySelector('.mmp_header')

      if (header && this.hasOpenedMenu() === false) {
        header.classList.remove('has_active_menu')
      }
    },
    event () {
      const _this = this
      const header = document.querySelector('.mmp_header')

      // 페이지 스크롤 감시
      window.addEventListener('scroll', (e) => {
        _this.checkScrollPosition()
      })

      // 헤더 영역 마우스오버 감시
      if (header) {
        header.addEventListener('mouseover', (e) => {
          if (this.isDesktop) _this.changeTheme('white')
        })
        header.addEventListener('mouseout', (e) => {
          if (this.isDesktop && !header.classList.contains('collapse')) {
            _this.changeTheme('dark')
          }
        })
      }
    },
    // String 내 태그 제거
    removeTag (str) {
      return str.replaceAll(/<\/?[^>]+(>|$)/g, '')
    },
    // 스크롤 위치가 상단에서 벗어났는지 확인 후 헤더 스타일 변경
    checkScrollPosition () {
      const gap = this.scrollGap
      const scrollPos = window.scrollY
      const header = document.querySelector('.mmp_header')

      if (this.isDesktop && header) {
        if (header.classList.contains('fixed')) {
          if (scrollPos > gap) {
            this.changeTheme('white')
            this.changeCollapse('collapse')
          } else {
            this.changeTheme('dark')
            this.changeCollapse('expand')
          }
        }
      }
    },
    // 헤더 색상 테마 변경 (마우스 오버, 페이지 스크롤시 변경)
    changeTheme (theme) {
      const header = document.querySelector('.mmp_header')

      if (header) {
        if (theme === 'white') {
          header.classList.remove('theme_dark')
          header.classList.add('theme_white')
        } else {
          header.classList.remove('theme_white')
          header.classList.add('theme_dark')
        }
      }
    },
    changeCollapse (v) {
      const header = document.querySelector('.mmp_header')

      if (header) {
        if (v === 'collapse') {
          header.classList.add('collapse')
        } else {
          header.classList.remove('collapse')
        }
      }
    },
    // home 으로 이동
    goMain () {
      if (this.$route.name === 'index') return
      this.$router.push({name: 'index'})
    },
    // 페이지 이동
    gotoPage (url) {
      location.href = url
    },

    // 카테고리 메뉴 열기
    showCategoryMenu () {
      const categoryMenuBtn = this.$refs.categoryMenuBtn
      const categoryMenu = this.$refs.categoryMenu

      if (this.isDesktop) {
        this.addHeaderActiveClass()
      } else {
        document.body.classList.add('overflow')
      }

      if (categoryMenuBtn) categoryMenuBtn.classList.add('active')
      if (categoryMenu) categoryMenu.classList.add('active')
      if (this.$refs.CompMmpCategoryMenu) {
        this.$refs.CompMmpCategoryMenu.initCategoryMenu()
      }
    },
    // 카테고리 메뉴 닫기
    hideCategoryMenu () {
      const header = document.querySelector('.mmp_header')
      const categoryMenuBtn = this.$refs.categoryMenuBtn
      const categoryMenu = this.$refs.categoryMenu
      const scrollEl = document.querySelectorAll('.wrap_category_menu_expand .custom_scroll')
      let isMoSearchOpened = false

      if (!this.isDesktop && header && header.classList.contains('has_search_ui')) isMoSearchOpened = true

      if (!isMoSearchOpened) {
        if (categoryMenu) categoryMenu.classList.remove('active')
        if (categoryMenuBtn) categoryMenuBtn.classList.remove('active')

        // 스크롤 초기화
        if (scrollEl.length > 0) {
          for (let i = 0; i < scrollEl.length; i++) {
            scrollEl[i].scroll({top: 0})
          }
        }

        // 열려 있는 메뉴가 없는 경우 헤더에 'has_active_menu' 클래스 제거
        if (this.isDesktop) {
          this.removeHeaderActiveClass()
        } else {
          document.body.classList.remove('overflow')
        }
      }
    },
    // 이벤트 메뉴 열기 (PC)
    showEventMenuPc () {
      const eventMenuBtn = document.querySelector('.btn_event_menu')
      const eventMenu = this.$refs.eventMenuPc ? this.$refs.eventMenuPc.$el : null

      this.addHeaderActiveClass()
      if (eventMenuBtn) eventMenuBtn.classList.add('active')
      if (eventMenu) this.isEventMenuOpened = true
    },
    // 이벤트 메뉴 닫기 (PC)
    hideEventMenuPc () {
      const eventMenuBtn = document.querySelector('.btn_event_menu')
      const eventMenu = this.$refs.eventMenuPc ? this.$refs.eventMenuPc.$el : null

      if (eventMenuBtn) eventMenuBtn.classList.remove('active')
      if (eventMenu) this.isEventMenuOpened = false

      // 열려 있는 메뉴가 없는 경우 헤더에 'has_active_menu' 클래스 제거
      this.removeHeaderActiveClass()
    },
    // 이벤트 메뉴 열기 (MO)
    showEventMenuMo () {

    },
    // 이벤트 메뉴 닫기 (MO)
    hideEventMenuMo () {

    },
    // 헤더 영역에 열려있는 레이어가 존재하는지 여부 반환
    hasOpenedMenu () {
      const layers = [
        this.$refs.categoryMenu, // 카테고리 메뉴
        document.querySelector('wrap_event_menu_expand') // 이벤트 메뉴
      ]
      let ret = false
      let i, layer

      for (i = 0; i < layers.length; i++) {
        layer = layers[i]
        if (layer && layer.classList.contains('active')) ret = true
      }

      return ret
    },
    closeAllHeaderLayer () {
      if (this.hasOpenedMenu()) {
        this.hideCategoryMenu()
        this.hideEventMenuPc()
        this.hideEventMenuMo()
      }
    },

    // 카테고리 메뉴 마우스 오버 제어 (PC 전용)
    categoryMenuOver (event) {
      if (this.isDesktop) {
        const currMenu = event.currentTarget // 현재 포커스 링크
        const currIndex = Number(currMenu.getAttribute('data-category-index')) // 현재 포커스 링크의 순서
        const currDepth = Number(currMenu.getAttribute('data-category-depth')) // 현재 포커스 링크의 depth
        const siblingList = document.querySelectorAll('.wrap_category_menu_expand .link_category_item[data-category-depth="' + currDepth + '"]') // 같은 레벨의 메뉴 엘리먼트들
        let item

        // hover 클래스 정리
        for (item of siblingList) {
          if (item === currMenu) {
            item.classList.add('active')
          } else {
            item.classList.remove('active')
          }
        }

        // 현재 포커스 인덱스 저장
        if (currDepth === 1) {
          this.category1DepthIndex = currIndex // 현재 포커스 인덱스 저장
          this.getSubCategory(currIndex)
        } else if (currDepth === 2) {
          this.category2DepthIndex = currIndex // 현재 포커스 인덱스 저장
          this.getSubCategory(this.category1DepthIndex, currIndex)
        } else {
          this.category3DepthIndex = currIndex // 현재 포커스 인덱스 저장
        }
      }
    },
    onClickTotalSearch () { // 검색 여닫기
      this.$emit('onClickTotalSearch')
    },
    gotoLink (item) {
      this.$emit('hideEventMenuPc')
      this.goPotltLink(item)
    },
    // 알림 아이콘 클릭
    onClickAlram () {
      this.openGnbLayer('gnb__alarm')
      this.toggleFlg = !this.toggleFlg

      if (this.toggleFlg) {
        this.$refs.headerAlarmBtn.classList.add('focus')
        this.getNewAlarmList()
      } else {
        this.$refs.headerAlarmBtn.classList.remove('focus')

        if (!this.alramList) {
          return false
        } else {
          if (this.alramList.some(item => item.newYn === 'Y')) {
            this.updateNewAlarmRead()
          }
        }
      }
    },
    // 나의 공간 아이콘 클릭
    memberClick () {
      this.openGnbLayer('gnb__member')
      if (!this.isLogin) this.moveToLogin()
    },
    closeGnbLayer (target) {
      let $target = document.querySelector('.' + target)
      document.querySelectorAll('.gnb__layer').forEach( $item => {
        if ($item === $target) {
          // 나의공간 버튼에 'active' 클래스 제거
          if ($item.classList.contains('gnb__member')) {
            this.$refs.headerMemberBtn.classList.remove('active')
          }

          $item.classList.remove('active')
        }
      })
    },
    // 알림 아이콘, 나의공간 아이콘 클릭시 팝업메뉴 처리
    openGnbLayer (target) {
      let $target = document.querySelector('.' + target)

      document.querySelectorAll('.gnb__layer').forEach( $item => {
        if ($item === $target) {
          // 나의공간 버튼에 'active' 클래스 토글
          if ($item.classList.contains('gnb__member')) {
            this.$refs.headerMemberBtn.classList.toggle('active')
          }

          $item.classList.toggle('active')
          if (this.isMobile) {
            document.body.classList.toggle('fixed_body')
          }
        } else {
          $item.classList.remove('active')
        }
      })
    },
    // 로그아웃
    async logOut () {
      var confirmResult = await this.$popup.confirm(this.$el, {title: '로그아웃', contents: '로그아웃 하시겠습니까?', scrollLock: false})
      if (confirmResult) {
        let isNrwMobile = window.vue.getStore('mmpAuth').getters.isNrwMobile
        this.fetchDataSync('memberLogout', {isNrwMobile: isNrwMobile})
        this.$utils.user.logout()
        this.$goPage({'name': 'index'})
      }
    },
    // 더보기
    showMore () {
      this.showMoreButtonClickCount++
      console.log('this.limitCount===>', this.limitCount)
      this.getNewAlarmList()
    },
    // 나의공간으로 이동
    openMyPage () {
      this.$goPage({name: 'MyDashbrd'})
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/pages/nrw/layouts/NrwHeader.vue